const getScreenDependentSettings = (screenWidth, currentInnerStyleRight) => {
  let depthFactor
  let newInnerStyleRight = currentInnerStyleRight

  if (screenWidth <= 380) {
    depthFactor = 0.5
    newInnerStyleRight = '10px'
  } else if (screenWidth <= 420) {
    depthFactor = 1
    newInnerStyleRight = '10px'
  } else if (screenWidth <= 480) {
    depthFactor = 1.2
  } else {
    depthFactor = 0.6
    newInnerStyleRight = '20px'
  }
  return { depthFactor, innerStyleRight: newInnerStyleRight }
}

const getBasePanelTransform = (rotationY, translateZValue) => {
  return `rotateY(${rotationY}deg) translateZ(${translateZValue}px) rotateY(${-rotationY}deg)`
}

export const animateSlider = (carousel, activeGroup) => {
  if (!carousel) {
    return
  }

  const rotateInt = parseInt(carousel.dataset.rotateInt || 0, 10)
  const inner = carousel.querySelector('.inner-carousel')
  const cards = carousel.querySelectorAll('.inner-carousel > div')

  if (!inner) {
    return
  }
  if (!cards || cards.length === 0) {
    return
  }
  const numCards = cards.length
  const panelSize = inner.clientWidth
  const screenWidth = window.innerWidth

  const { depthFactor, innerStyleRight } = getScreenDependentSettings(screenWidth, inner.style.right)
  if (inner.style.right !== innerStyleRight) {
    inner.style.right = innerStyleRight
  }

  const rotationPerPanelY = numCards > 0 ? 360 / numCards : 0

  let translateZValue
  if (numCards >= 3) {
    translateZValue = Math.round(panelSize / 2 / Math.tan(Math.PI / numCards)) * depthFactor
  } else {
    translateZValue = 0
  }

  if (numCards === 5 || numCards === 3 || numCards === 2) {
    for (let i = 0; i < numCards; i++) {
      const child = cards[i]
      const currentPanelRotationY = rotateInt * rotationPerPanelY + i * rotationPerPanelY
      let newTransform = getBasePanelTransform(currentPanelRotationY, translateZValue)
      let isPositionedClassSet = false

      child.style.zIndex = 'auto'
      child.classList.remove('clockwise', 'front', 'counterclockwise', 'animation-slide')

      const rawRotationMod360 = currentPanelRotationY % 360
      const normalizedAngle = ((rawRotationMod360 % 360) + 360) % 360

      if (normalizedAngle === 0) {
        child.classList.add('front')
        child.style.zIndex = 100
        isPositionedClassSet = true
        if (numCards === 2) {
          newTransform += ' translateZ(50px)'
        }
      } else {
        if (numCards === 5) {
          if (normalizedAngle === rotationPerPanelY || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -288)) {
            child.classList.add('clockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(4rem) translateX(60px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(5rem) translateX(28px)'
            else newTransform += ' translateZ(20px) translateY(8dvh) translateX(80px)'
          } else if (normalizedAngle === (360 - rotationPerPanelY) % 360 || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -72)) {
            child.classList.add('counterclockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(4rem) translateX(-70px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(5rem) translateX(-55px)'
            else newTransform += ' translateZ(20px) translateY(8dvh) translateX(-80px)'
          } else if (normalizedAngle === 2 * rotationPerPanelY || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -216)) {
            child.classList.add('clockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(5dvh) translateX(10px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem) translateX(10px)'
            else newTransform += ' translateZ(20px) translateY(0) translateX(30px)'
          } else if (normalizedAngle === (360 - 2 * rotationPerPanelY) % 360 || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -144)) {
            child.classList.add('counterclockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(5dvh) translateX(-20px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem) translateX(-10px)'
            else newTransform += ' translateZ(20px) translateY(0) translateX(-30px)'
          }
        } else if (numCards === 3) {
          if (normalizedAngle === rotationPerPanelY || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -240)) {
            child.classList.add('clockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(3rem) translateX(60px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem) translateX(70px)'
            else newTransform += ' translateZ(20px) translateY(0dvh) translateX(100px)'
          } else if (normalizedAngle === (360 - rotationPerPanelY) % 360 || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -120)) {
            child.classList.add('counterclockwise')
            isPositionedClassSet = true
            if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(3rem) translateX(-70px)'
            else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem) translateX(-75px)'
            else newTransform += ' translateZ(20px) translateY(0dvh) translateX(-100px)'
          }
        } else if (numCards === 2) {
          if (activeGroup === 2) {
            if (normalizedAngle === rotationPerPanelY || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -180)) {
              child.classList.add('clockwise')
              isPositionedClassSet = true
              if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(2.5rem)'
              else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem)'
              else newTransform += ' translateZ(20px) translateY(15dvh)'
            }
          } else {
            if (normalizedAngle === rotationPerPanelY || (normalizedAngle === ((360 + rawRotationMod360) % 360) && rawRotationMod360 === -180)) {
              child.classList.add('clockwise')
              isPositionedClassSet = true
              if (screenWidth <= 380) newTransform += ' translateZ(20px) translateY(2.5rem) translateX(-20px)'
              else if (screenWidth <= 480) newTransform += ' translateZ(20px) translateY(2rem)  translateX(-30px)'
              else newTransform += ' translateZ(20px) translateY(15dvh) translateX(-60px)'
            }
          }
        }
      }

      if (!isPositionedClassSet) {
        child.classList.add('animation-slide')
      }
      child.style.transform = newTransform
    }
  } else {
    for (let i = 0; i < numCards; i++) {
      const child = cards[i]
      const currentPanelRotationY = rotateInt * rotationPerPanelY + i * rotationPerPanelY
      child.style.transform = getBasePanelTransform(currentPanelRotationY, translateZValue)
      child.style.zIndex = 'auto'
      child.classList.remove('clockwise', 'front', 'counterclockwise')
      child.classList.add('animation-slide')
    }
  }
}
